import { render } from "./editOrderOperatorModel.vue?vue&type=template&id=3a1d480b"
import script from "./editOrderOperatorModel.vue?vue&type=script&lang=js"
export * from "./editOrderOperatorModel.vue?vue&type=script&lang=js"

import "./editOrderOperatorModel.vue?vue&type=style&index=0&id=3a1d480b&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__